import React, { useContext, useEffect, useState } from "react";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import { AuthContext } from "../../context/AuthContext";
import "../DocumentsReport/DocumentsReport.css";
import "./Contacts.css";
import MenuTop from "../../components/MenuTop/MenuTop";
import ModalConfirm from "../../components/ModalConfirm/ModalConfirm";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ModalAddContact from "../../components/ModalAddContact/ModalAddContact";
import { ContactContext } from "../../context/ContactContext";
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import TableComponentOther from "../../components/TableComponentOther/TableComponentOther";
import { LoadingContext } from "../../context/LoadingContext";
import { useToast } from "../../context/ToastContext";
import { getContactsByUserIdGat, ContactListFilters } from "../../gateways/ContactsGateway";
import * as XLSX from "xlsx";

const Contacts = () => {
  const { objUserTk } = useContext(AuthContext);
  const { setLoading } = useContext(LoadingContext);
  const showToast = useToast();
  const {
    getContact,
    tableContacts,
    totalContats,
    getContactsByUserId,
    deleteContact,
  } = useContext(ContactContext);
  const [openModalDelete, setOpenModalDelete] = useState({
    open: false,
    idDelete: "",
  });
  const [openModal, setOpenModal] = useState(false);

  const [filterName, setFilterName] = useState("");
  const [filterEmail, setFilterEmail] = useState("");
  const [filterPhone, setFilterPhone] = useState("");

  const buildFilters = (): ContactListFilters => ({
    ...(filterName.trim() && { name: filterName.trim() }),
    ...(filterEmail.trim() && { email: filterEmail.trim() }),
    ...(filterPhone.trim() && { phone: filterPhone.trim() }),
  });

  const handleFilter = () => {
    void getContactsByUserId(1, buildFilters());
  };

  const handleExport = async () => {
    try {
      setLoading(true);
      const response = await getContactsByUserIdGat(
        objUserTk.UserId,
        1,
        10_000,
        buildFilters()
      );
      const contacts = response.data?.data?.contacts || [];
      const rows = contacts.map((c: any) => ({
        Nome: c.name ?? "",
        "E-mail": c.email ?? "",
        Telefone: c.phoneNumber ?? "",
      }));
      const ws = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Contatos");
      XLSX.writeFile(
        wb,
        `contatos-${new Date().toISOString().slice(0, 10)}.xlsx`
      );
      showToast("success", "Exportação concluída.");
    } catch (error: any) {
      console.error(error);
      showToast(
        "error",
        error?.response?.data?.error?.message || "Erro ao exportar."
      );
    } finally {
      setLoading(false);
    }
  };

  const headCells: readonly any[] = [
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "Nome",
    },
    {
      id: "email",
      numeric: false,
      disablePadding: false,
      label: "E-mail",
    },
    {
      id: "phoneNumber",
      numeric: true,
      disablePadding: false,
      label: "Telefone",
    },
    {
      id: "",
      numeric: false,
      disablePadding: false,
      label: "",
    },
  ];

  const editItem = async (id: any) => {
    await getContact(id);
    setOpenModal(true);
  };

  const removeItem = async () => {
    await deleteContact(openModalDelete.idDelete);
    setOpenModalDelete({ open: false, idDelete: "" });
  };

  const getContactsByUserIdPage = async (page: number) => {
    await getContactsByUserId(page);
  };

  useEffect(() => {
    const getData = async () => {
      await getContactsByUserId(1, {});
    };
    getData();
  }, []);

  return (
    <>
      <LoadingSpinner />

      <MenuTop />

      <div
        className="contacts-page mt-3 ml-3 mr-2 pt-4 pb-4 pl-4 pr-4 d-flex"
        style={{
          height: "100%",
          backgroundColor: "#fff",
          gap: "20px",
          flexDirection: "column",
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
        }}
      >
        <div className="d-flex flex-column" style={{ gap: "16px" }}>
          <div
            className="d-flex"
            style={{ alignItems: "center", gap: "17px" }}
          >
            <span className="title-page-document">CONTATOS</span>
            <label
              className="icon-upload-document"
              onClick={() => setOpenModal(true)}
            >
              <PersonAddIcon style={{ color: "#fff", cursor: "pointer" }} />
            </label>
          </div>

          <div className="report-filters-row contacts-filters-row">
            <div className="report-filter-field">
              <label className="report-filter-label">Nome</label>
              <input
                type="text"
                className="report-filter-input"
                placeholder="Buscar por nome"
                value={filterName}
                onChange={(e) => setFilterName(e.target.value)}
              />
            </div>
            <div className="report-filter-field">
              <label className="report-filter-label">E-mail</label>
              <input
                type="text"
                className="report-filter-input"
                placeholder="Buscar por e-mail"
                value={filterEmail}
                onChange={(e) => setFilterEmail(e.target.value)}
              />
            </div>
            <div className="report-filter-field">
              <label className="report-filter-label">Telefone</label>
              <input
                type="text"
                className="report-filter-input"
                placeholder="Buscar por telefone"
                value={filterPhone}
                onChange={(e) => setFilterPhone(e.target.value)}
              />
            </div>
            <div className="report-filter-field report-filter-actions">
              <label className="report-filter-label report-filter-label-invisible">
                Ação
              </label>
              <div className="report-filter-buttons">
                <button
                  type="button"
                  className="report-filter-btn"
                  onClick={handleFilter}
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  className="report-filter-btn report-filter-btn-export"
                  onClick={handleExport}
                >
                  Exportar dados
                </button>
              </div>
            </div>
          </div>
        </div>

        <hr className="my-2" style={{ color: "#DDD", width: "100%" }} />

        {tableContacts?.length > 0 ? (
          <>
            <div
              className="contacts-table-wrap"
              key={tableContacts?.map((item) => item.id).join("-")}
            >
              <TableComponentOther
                showId={false}
                page={0}
                rowsPerPage={10}
                headCells={headCells}
                rows={tableContacts}
                alignCells="left"
                editItem={editItem}
                removeItem={(id: any) =>
                  setOpenModalDelete({
                    open: true,
                    idDelete: id,
                  })
                }
              />
            </div>
            {totalContats > 1 && (
              <div className="d-flex justify-content-end pb-2 pr-2">
                <PaginationMaterial
                  onChange={(e: any, page: number) =>
                    getContactsByUserIdPage(page || 0)
                  }
                  count={totalContats}
                />
              </div>
            )}
          </>
        ) : (
          <div className="report-empty-state">
            <span>Nenhum contato encontrado</span>
          </div>
        )}
      </div>
      <ModalConfirm
        openModal={openModalDelete.open}
        closeModal={() => setOpenModalDelete({ open: false, idDelete: "" })}
        handleConfirm={removeItem}
      />

      <ModalAddContact
        openModal={openModal}
        closeModal={() => setOpenModal(false)}
      />
    </>
  );
};

export default Contacts;
